import { BookmarkList } from "@/app/core/models/domain/BookmarkList";
import { Actions, createComposable, Getters, Module, Mutations } from "vuex-smart-module";
import { getBookmarks, addBookmark, deleteBookmark as deleteBookmarkApi } from "@/api/bookmarks";

export class BookmarkState {
  bookmarkList = null;
  bookmarkListCount = 0;
}
export class BookmarkGetters extends Getters {
  get bookmarkList() {
    return this.state.bookmarkList;
  }
  get bookmarksCount() {
    return this.state.bookmarkListCount;
  }
}
export class BookmarkMutations extends Mutations {
  setBookmarkList(bookmarkList) {
    this.state.bookmarkList = bookmarkList;
  }
  setBookmarkListCount(count) {
    this.state.bookmarkListCount = count;
  }
}
export class BookmarkActions extends Actions {
  async getBookmarkList() {
    const response = await getBookmarks();
    this.mutations.setBookmarkList(response);
    this.mutations.setBookmarkListCount(response.bookmarksCount);
  }
  async addBookmark(orderId) {
    const response = await addBookmark(orderId);
    this.mutations.setBookmarkList(response);
    this.mutations.setBookmarkListCount(response.bookmarksCount);
  }
  async deleteBookmark(orderId) {
    await deleteBookmarkApi(orderId);
    // Refresh the bookmark list after deletion
    await this.getBookmarkList();
  }
}
export const bookmarkModule = new Module({
  state: BookmarkState,
  getters: BookmarkGetters,
  mutations: BookmarkMutations,
  actions: BookmarkActions,
});
export const useBookmarkModule = createComposable(bookmarkModule);
